import { Button, Modal, Typography, Box } from '@mui/material';

type Props = {
  showConfirmClose: boolean;
  handleOnchange: (value: 'DISCARD' | 'CANCEL') => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
};

const ConfirmCloseDialog = ({
  showConfirmClose,
  handleOnchange,
  title = 'Unsaved Changes',
  message = 'You have unsaved changes. Are you sure you want to discard them?',
  confirmLabel = 'Discard'
}: Props) => {
  return (
    <Modal
      open={showConfirmClose}
      onClose={() => handleOnchange('CANCEL')}
      aria-labelledby="confirm-close-title"
      aria-describedby="confirm-close-description"
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1000
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 600 },
          maxWidth: '95vw',
          p: { xs: 3, sm: 4 },
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          pb: 2
        }}
      >
        <Typography id="confirm-close-title" variant="h4" component="h2">
          {title}
        </Typography>
        <Typography id="confirm-close-description" sx={{ mt: 2 }}>
          {message}
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={() => handleOnchange('CANCEL')} variant="outlined">
            Back
          </Button>
          <Button
            onClick={() => {
              handleOnchange('DISCARD');
            }}
            variant="contained"
            color="error"
          >
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmCloseDialog;
